module.exports = __webpack_public_path__ + "img/logindun.d263256d.svg";